import * as basicScroll from 'basicscroll';

export default (function (){

    const defaults = {
        offsetMax: "50vh",
    }

    function init() {
        // Delay start to prevent problems with positioning
        setTimeout(setup, 1);
    }

    function setup() {

        const containers = document.querySelectorAll('*[data-parallax-container]');

        for (let i = 0; i < containers.length; i++) {

            let currentCounter = 0;

            let offsetMax = defaults.offsetMax;

            const offset = {
                value: parseFloat(offsetMax),
                unit: "px",
            }

            if (typeof offsetMax === "string") {

                let match, value, unit;

                [match, value, unit] = offsetMax.match(/^([\d.]*)(\D*)$/);

                if (value !== "") {
                    offset.value = parseFloat(value);
                }

                if (unit !== "") {
                    offset.unit = unit;
                }

            }

            const container = containers[i],
                  elements = container.querySelectorAll('*[data-parallax-factor]');

            container.style.setProperty('--parallax-offset-max', `${1/2 * offset.value}${offset.unit}`);

            for (let j = 0; j < elements.length; j++) {

                const element = elements[j];

                let factor = element.dataset.parallaxFactor;

                if (factor === "" || factor === "auto") {
                    factor = (currentCounter + 1);
                } else if (factor.match(/^[+-]/)) {
                    currentCounter += parseFloat(element.dataset.parallaxFactor);
                    factor = currentCounter;
                } else {
                    factor = parseFloat(factor);
                }

                const instance = basicScroll.create({
                    elem: container,
                    direct: element,
                    from: 'top-bottom',
                    to: 'bottom-top',
                    props: {
                        '--parallax-translateY': {
                            from: `${ 1/2 * offset.value * factor}${offset.unit}`,
                            to:   `${-1/2 * offset.value * factor}${offset.unit}`,
                        },
                    },
                });

                instance.start();

                currentCounter = factor;

            }

        };

    }

    return {
        init: init
    }

})();
